import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../../actions/auth';

const Login = ({ login, isAuthenticated }) => {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });


    const { username, password } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = async e => {
        e.preventDefault();
        login({ username, password });
    };

    if (isAuthenticated) {
        return <Redirect to="/gestione-portale" />
    }


    return (
        <section className="fd-section wide bg-prim">
            <div className="w-layout-blockcontainer fd-container fd-window-w w-container">
                <div className="fd-wrap">
                    <div className="space-20"></div>
                    <img src="/assets/media/noi_con_voi-fondazione_danesino-logo.svg" alt="" className="image" data-savepage-loading="lazy" />
                    <div className="space-40"></div>
                    <div className="fd-form w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" data-wf-page-id="677af35aeb367078c9ef9568" data-wf-element-id="206960bc-98cd-9bec-5c67-bb4157349c75" aria-label="Email Form"  onSubmit={e => onSubmit(e)}>
                            <label htmlFor="Password">Username</label>
                            <input className="input w-input" maxLength="256" name="username" data-name="username" placeholder="Inserisci il tuo nome" type="text" id="username" required={true} value={username} onChange={e => onChange(e)}/>
                            <label htmlFor="Password">Password</label>
                            <input className="input w-input" maxLength="256" name="password" placeholder="Inserisci la password che ti è stata comunicata" type="password" id="password" required={true} value={password} onChange={e => onChange(e)}/>
                            <input type="submit" data-wait="Un attimo..." className="submit-button w-button" value="Accedi" />
                        </form>
                    </div>
                <div className="space-20"></div>
                </div>
            </div>
        </section>
    )
};

Login.propTypes = {
    login: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login })(Login);